import { Slide } from "@mui/material";
import React from "react";

const DialogTransition = React.forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const TransitionDown = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

export { DialogTransition, TransitionDown };
